module.exports = __webpack_public_path__ + "static/assets/cd485f122a8a612bc3b64d2625ead46b.png";